import React from 'react'
import Layout from '../../../components/Default/Layout'
import '../../../components/ParagraphUnderPhoto/styles.css'
import { graphql } from 'gatsby'
import { Breadcrumb } from 'gatsby-plugin-breadcrumb'
import ServiceHeader from '../../../components/Services/ServiceOverview/ServiceHeader'
import './styles.css'
import Img from 'gatsby-image'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { Link } from '@reach/router'
import { ResponsiveImage } from '../../../components/ResponsiveImage'
const NasTym = ({ data: { page, image1 }, pageContext }) => {
  const {
    breadcrumb: { crumbs },
  } = pageContext

  const URLbase = '/o-nas/nas-tym/'

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  }
  const { image, title } = page.frontmatter
  return (
    <Layout
      meta={page.frontmatter.meta || false}
      title={page.frontmatter.title || false}
      metaCrumb={crumbs}
    >
      <ServiceHeader
        title={title}
        backgroundImage={
          !!image.childImageSharp ? image.childImageSharp.fluid.src : image
        }
      />
      <Breadcrumb crumbs={crumbs} crumbLabel={'Náš tým'} />

      <div className="Paragraph--Wrapper container NasTym">
        <p>
          Součástí týmu jsou odborníci na finanční či mzdové účetnictví, přímé i
          nepřímé daně, firemní poradenství či soudní znalci v oblasti
          účetnictví a daní. Důležité pro nás je, aby se každý člen ve své
          specializaci neustále rozvíjel a sledoval veškeré legislativní změny.
        </p>
        <p>
          Spolupracovat budete výhradně s certifikovanými daňovými poradci a
          kvalifikovanými účetními tak, aby veškeré výstupy byly precizní, včas
          a mohli jste se na nás spolehnout. Celý tým zároveň funguje efektivně
          jako celek, s ohledem nejen na profesní specializaci, ale také s
          respektem k osobnostním profilům členů a důrazem na rozvoj soft
          skills. Díky tomu můžete očekávat nejen perfektní daňové a účetní
          výstupy, ale také profesionální jednání a snadnou komunikaci.
        </p>
        <p>
          Hlavní osu týmu pak tvoří zakládající partneři společnosti a poradci
          zapsaní v Komoře daňových poradců – Jan Kotala a Lukáš Eisenwort. Oba
          vycházejí z bohaté praxe v poradenských společnostech, neustále se
          vzdělávají, sami přednášejí a od roku 2015 poskytují služby pod
          hlavičkou vlastní firmy, EK Partners, s.r.o.
        </p>
      </div>
      <div className="container" style={{ textAlign: 'center' }}>
        <div className="row justify-content-end align-items-center">
          <div className="col-lg-12 blue-line-two"></div>
          <div className="col-lg-6">
            <Link to={URLbase + 'lukas-eisenwort/'}>
              <ResponsiveImage
                className="NasTym--ImageMain"
                src="/images/team/lukas_eisenwort.jpg"
                alt="lukas-eisenwort"
                width="252"
              />
              <p className="NasTym--Name">Lukáš Eisenwort</p>
              <p className="NasTym--Position">daňový poradce</p>
            </Link>
          </div>
          <div className="col-lg-6">
            <Link to={`${URLbase}jan-kotala/`}>
              <ResponsiveImage
                className="NasTym--ImageMain"
                src="/images/team/jan_kotala.jpg"
                alt="jan-kotala"
                width="252"
              />
              <p className="NasTym--Name">Jan Kotala</p>
              <p className="NasTym--Position">daňový poradce</p>
            </Link>
          </div>
        </div>

        <h4 className="NasTym--H4">Daňový poradci</h4>
        <Carousel
          responsive={responsive}
          additionalTransfrom={0}
          arrows
          autoPlaySpeed={300}
          centerMode={false}
          className="NasTym--Carousel--Wrap"
          dotListClass=""
          draggable
          focusOnSelect={false}
          infinite
          itemClass=""
          keyBoardControl
          minimumTouchDrag={80}
          renderButtonGroupOutside={true}
          renderDotsOutside={false}
          showDots={true}
          dotListClass="custom-dot-list-style"
        >
          <Link to={`${URLbase}jana-peterkova/`}>
            <div className="NasTym--Card">
              <img
                className="NasTym--Image"
                src="/images/team/jana_peterkova.jpg"
                alt=""
              />
              <p className="NasTym--Name">Jana Peterková</p>
              <p className="NasTym--Position">daňový poradce</p>
            </div>
          </Link>
          <Link to={`${URLbase}jan-tecl/`}>
            <div className="NasTym--Card">
              <img
                className="NasTym--Image"
                src="/images/team/jan_tecl.jpg"
                alt=""
              />
              <p className="NasTym--Name">Jan Tecl</p>
              <p className="NasTym--Position">daňový poradce</p>
            </div>
          </Link>
          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/zuzana_tregnerova.jpg"
              alt=""
            />
            <p className="NasTym--Name">Zuzana Tregnerová</p>
            <p className="NasTym--Position">daňový poradce</p>
          </div>
          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/alena_fleischmannova.jpg"
              alt=""
            />
            <p className="NasTym--Name">Alena Fleischmannová</p>
            <p className="NasTym--Position">daňový poradce</p>
          </div>

          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/anna_pestova.jpg"
              alt=""
            />
            <p className="NasTym--Name">Anna Peštová</p>
            <p className="NasTym--Position">daňový poradce</p>
          </div>

          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/gabriela_kopecka.jpg"
              alt=""
            />
            <p className="NasTym--Name">Gabriela Kopecká</p>
            <p className="NasTym--Position">daňový poradce</p>
          </div>
        </Carousel>

        <h4 className="NasTym--H4">Asistent daňového poradce</h4>
        <Carousel
          responsive={responsive}
          additionalTransfrom={0}
          arrows
          autoPlaySpeed={300}
          centerMode={false}
          className="NasTym--Carousel--Wrap"
          dotListClass=""
          draggable
          focusOnSelect={false}
          infinite
          itemClass=""
          keyBoardControl
          minimumTouchDrag={80}
          renderButtonGroupOutside={true}
          renderDotsOutside={false}
          showDots={true}
          dotListClass="custom-dot-list-style"
        >
          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/eliska_behalova.jpg"
              alt=""
            />
            <p className="NasTym--Name">Eliška Běhalová</p>
            <p className="NasTym--Position">Asistent daňového poradce</p>
          </div>

          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/jakub_beran.jpg"
              alt=""
            />
            <p className="NasTym--Name">Jakub Beran</p>
            <p className="NasTym--Position">Asistent daňového poradce</p>
          </div>

          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/katerina_zackova.jpg"
              alt=""
            />
            <p className="NasTym--Name">Kateřina Žáčková</p>
            <p className="NasTym--Position">Asistent daňového poradce</p>
          </div>

          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/patrik_marek.jpg"
              alt=""
            />
            <p className="NasTym--Name">Patrik Marek</p>
            <p className="NasTym--Position">Asistent daňového poradce</p>
          </div>

          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/katerina_zackova.jpg"
              alt=""
            />
            <p className="NasTym--Name">Kateřina Žáčková</p>
            <p className="NasTym--Position">Asistent daňového poradce</p>
          </div>

          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/zuzana_loudova.jpg"
              alt=""
            />
            <p className="NasTym--Name">Zuzana Loudová</p>
            <p className="NasTym--Position">Asistent daňového poradce</p>
          </div>

          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/anh_nguyen.jpg"
              alt=""
            />
            <p className="NasTym--Name">Anh Duc Nguyen</p>
            <p className="NasTym--Position">Asistent daňového poradce</p>
          </div>

          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/sona_tureckova.jpg"
              alt=""
            />
            <p className="NasTym--Name">Soňa Turečková</p>
            <p className="NasTym--Position">Asistent daňového poradce</p>
          </div>

          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/dominika_siplova.jpg"
              alt=""
            />
            <p className="NasTym--Name">Dominika Šiplová</p>
            <p className="NasTym--Position">Asistent daňového poradce</p>
          </div>
        </Carousel>

        <h4 className="NasTym--H4">Finanční účetní</h4>
        <Carousel
          responsive={responsive}
          additionalTransfrom={0}
          arrows
          autoPlaySpeed={300}
          centerMode={false}
          className="NasTym--Carousel--Wrap"
          dotListClass=""
          draggable
          focusOnSelect={false}
          infinite
          itemClass=""
          keyBoardControl
          minimumTouchDrag={80}
          renderButtonGroupOutside={true}
          renderDotsOutside={false}
          showDots={true}
          dotListClass="custom-dot-list-style"
        >
          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/sandra_dolejsi.jpg"
              alt=""
            />
            <p className="NasTym--Name">Sandra Dolejší</p>
            <p className="NasTym--Position">Finanční účetní</p>
          </div>

          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/monika_oberreiterova.jpg"
              alt=""
            />
            <p className="NasTym--Name">Monika Oberreiterová</p>
            <p className="NasTym--Position">Finanční účetní</p>
          </div>

          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/eliska_pavlickova.jpg"
              alt=""
            />
            <p className="NasTym--Name">Eliška Pavlíčková</p>
            <p className="NasTym--Position">Finanční účetní</p>
          </div>

          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/lenka_platova.jpg"
              alt=""
            />
            <p className="NasTym--Name">Lenka Plátová</p>
            <p className="NasTym--Position">Finanční účetní</p>
          </div>

          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/jana_polanska.jpg"
              alt=""
            />
            <p className="NasTym--Name">Jana Polanská</p>
            <p className="NasTym--Position">Finanční účetní</p>
          </div>

          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/valerie_dolejsi.jpg"
              alt=""
            />
            <p className="NasTym--Name">Valerie Dolejší</p>
            <p className="NasTym--Position">Finanční účetní</p>
          </div>

          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/linh_tran.jpg"
              alt=""
            />
            <p className="NasTym--Name">Tran Thi Thuy Linh</p>
            <p className="NasTym--Position">Finanční účetní</p>
          </div>

          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/jana_vitova.jpg"
              alt=""
            />
            <p className="NasTym--Name">Jana Vítová</p>
            <p className="NasTym--Position">Finanční účetní</p>
          </div>
        </Carousel>

        <h4 className="NasTym--H4">Ostatní</h4>
        <Carousel
          responsive={responsive}
          additionalTransfrom={0}
          arrows
          autoPlaySpeed={300}
          centerMode={false}
          className="NasTym--Carousel--Wrap"
          dotListClass=""
          draggable
          focusOnSelect={false}
          infinite
          itemClass=""
          keyBoardControl
          minimumTouchDrag={80}
          renderButtonGroupOutside={true}
          renderDotsOutside={false}
          showDots={true}
          dotListClass="custom-dot-list-style"
        >
          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/hana_reznickova.jpg"
              alt=""
            />
            <p className="NasTym--Name">Hana Řezníčková</p>
            <p className="NasTym--Position">Asistentka</p>
          </div>

          <div className="NasTym--Card">
            <img
              className="NasTym--Image"
              src="/images/team/belinda_buresova.jpg"
              alt=""
            />
            <p className="NasTym--Name">Belinda Burešová</p>
            <p className="NasTym--Position">Asistentka</p>
          </div>
        </Carousel>
      </div>
      {!!image1 && !!image1.childImageSharp ? (
        <Img
          fluid={image1.childImageSharp.fluid}
          style={{ marginBottom: '-128px', marginTop: '128px' }}
          alt={title}
        />
      ) : (
        <img src={image1.src} alt="" />
      )}
    </Layout>
  )
}

export default NasTym

export const pageQuery = graphql`
  query NasTym {
    page: markdownRemark(frontmatter: { slug: { eq: "o-nas/nas-tym" } }) {
      ...Meta
      frontmatter {
        title
        image {
          childImageSharp {
            fluid(maxWidth: 2048, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    image1: file(relativePath: { eq: "nas-tym.jpg" }) {
      childImageSharp {
        fluid(quality: 100, maxWidth: 2048) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
